export default __webpack_public_path__ + "static/media/archiveIcon.6cae10ba.svg";